module.exports = __webpack_public_path__ + "/login_ui/img/mg-4d7239d123612a4221ab5e75abac7d9d.svg";